import { render } from "./unMatchSale.vue?vue&type=template&id=b842bf60&scoped=true"
import script from "./unMatchSale.vue?vue&type=script&lang=js"
export * from "./unMatchSale.vue?vue&type=script&lang=js"

import "./unMatchSale.vue?vue&type=style&index=0&id=b842bf60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b842bf60"]])

export default __exports__